module.exports = __webpack_public_path__ + "img/quizmayhem_banner_tv.8e59b9a1.jpg";